import * as React from "react";

const StretchedContent = (props: { className?: string; children: React.ReactNode }) => {
    return <div className={`stretched-content ${props.className || ""}`}>{props.children}</div>;
};

export default StretchedContent;
